import http from 'hub-http/clients/apiClient';
const USER_OBJECT_API_BASE_URL = 'user-objects/v1/app';
export default class UserObjectsApi {}
UserObjectsApi.updateUserProperties = (userId, userProperties, isViewingSelf = true) => {
  if (isViewingSelf) {
    return http.put(`${USER_OBJECT_API_BASE_URL}/users/`, {
      data: {
        propertyValues: userProperties
      }
    });
  } else if (userId) {
    return http.put(`${USER_OBJECT_API_BASE_URL}/users/${userId}`, {
      data: {
        propertyValues: userProperties
      }
    });
  }
};
UserObjectsApi.bulkUpdateUserProperties = bulkUpdateRequest => {
  return http.put(`${USER_OBJECT_API_BASE_URL}/users/batch`, {
    data: {
      appUpdateRequestByUserId: bulkUpdateRequest
    }
  });
};